import React from 'react';
import { useSelector } from 'react-redux';

import { notification } from 'antd';

import Messages from 'i18n/messages/home';

import { DownloadOutlined } from '@ant-design/icons';

import ContainerButton from 'common/components/button/ContainerButton';
import ItemButton from 'common/components/button/ItemButton';

import gridViewSelectors from 'common/components/grid-view/controllers/selectors';

import { downloadAplBlankTemplate } from 'services/apl';

import { saveFile } from 'utils/saveFile';
import { RibbonButton } from 'common/components';

const DownloadAplTemplate = () => {
  const selectedProducts = useSelector(
    gridViewSelectors.makeSelectDetailCurrentITemsSelection()
  );

  const handleDownloadTemplate = () => {
    downloadAplBlankTemplate().then((resp) => {
      if (resp.isSuccess) {
        saveFile(resp?.data?.url);
      } else {
        notification.error({
          message: resp?.message,
        });
      }
    });
  };

  return (
    <ContainerButton>
      <ItemButton>
        <RibbonButton
          size='small'
          icon={<DownloadOutlined style={{ height: 26 }} />}
          label={Messages.downloadAplTemplate}
          onClick={handleDownloadTemplate}
          disabled={selectedProducts?.length}
        />
      </ItemButton>
    </ContainerButton>
  );
};

export default DownloadAplTemplate;
